import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectTimerStatus, tickTimer } from './timerSlice';

const STORAGE_KEY = 'familysync_timer_state';

/**
 * Background timer that runs independently of route changes.
 * Uses setInterval (not rAF) so it keeps counting when the Timer page is unmounted.
 * Lives at App level so it never unmounts during navigation.
 */
export const BackgroundTimer = () => {
  const dispatch = useDispatch();
  const status = useSelector(selectTimerStatus);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (status !== 'running') {
      // Clear any existing interval when not running
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    // Start a 1-second interval to tick the timer even when off-page
    intervalRef.current = setInterval(() => {
      dispatch(tickTimer());
      
      // Also persist state after each tick for crash recovery
      try {
        const state = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          ...state,
          savedAt: Date.now()
        }));
      } catch (e) {
        // Ignore storage errors
      }
    }, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [status, dispatch]);

  // This component doesn't render anything
  return null;
};
